<template>
  <v-app class="blue-grey lighten-5">
    <Navbar />
    <v-content class="mb-1">
      <v-alert color="grey darken-1" class="mt-0 subtitle-1 white--text" v-model="snackbar">
        {{ text }}
        <v-btn color="yellow" @click="snackbar = false">Ok</v-btn>
      </v-alert>
      <router-view></router-view>
    </v-content>
    <v-footer dark height="auto">
      <v-card class="flex" flat tile>
        <v-flex xs6 md12>
          <v-card-actions class="grey darken-3 white--text justify-center">
            <a class="pa-2" rel="license">
              <img
                class="pa-2 font-weight-thin"
                alt="Creative Commons Licence"
                style="border-width:0"
                src="https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png"
              />
            </a>
            <br />
            <h4>This work is licensed under a Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International License.</h4>
          </v-card-actions>
        </v-flex>
        <v-flex xs6 right md12 class="pr-3 pb-3">
          <h4 class="grey--text ml-2 font-weight-light">Platform Developed by FRANCIS KAGAI</h4>
        </v-flex>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";

export default {
  components: { Navbar },
  name: "App",
  data() {
    return {
      snackbar: true,
      y: "bottom",
      x: null,
      mode: "",
      timeout: 6000,
      text:
        "We use cookies and other technologies to keep the site reliable and secure, tailor your experience and measure site performance, as described in our privacy policy and cookie policy."
    };
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
  }
};
</script>
